import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import ProductService from "services/ProductService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getProductApi = createAsyncThunk(
  "product/getProductApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductService.productSearchGrid(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getProductMobileById = createAsyncThunk(
  "product/getProductMobileById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ProductService.getProductMobileById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getProductById = createAsyncThunk(
  "product/getProductById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ProductService.getProductById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const addProductApi = createAsyncThunk(
  "product/addProductApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.addProduct(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateProductApi = createAsyncThunk(
  "product/updateProductApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.updateProduct(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateProductStateApi = createAsyncThunk(
  "product/updateProductStateApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.updateProductState(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delProductApi = createAsyncThunk(
  "product/delProductApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await ProductService.delProduct(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const copyProductsApi = createAsyncThunk(
  "product/copyProductsApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.copyProducts(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const groupCategoryApi = createAsyncThunk(
  "product/distributeProductsApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.groupCategory(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const changeStatusProductsApi = createAsyncThunk(
  "product/changeStatusProductsApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.changeStatusProducts(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const discountProductsApi = createAsyncThunk(
  "product/discountProductsApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.discountProducts(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//Update product variants, product add options
export const updateProductVariantApi = createAsyncThunk(
  "product/updateProductVariantApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.updateVariant(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getProductWarehouseList = createAsyncThunk(
  "product/getProductWarehouseList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ProductService.getProductWarehouseList(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllProductWarehouse = createAsyncThunk(
  "product/getAllProductWarehouse",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ProductService.getAllProductWarehouse(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delMultiProductsApi = createAsyncThunk(
  "product/delMultiProductsApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      const response = await ProductService.delMultiProducts(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//PRODUCT V2/V3
export const getAllProduct = createAsyncThunk(
  "product/productSearchGridV2",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductService.productSearchGridV2(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getSelectListWarehouseProduct = createAsyncThunk(
  "product/warehouseProductSearchGrid",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductService.warehouseProductSearchGrid(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllWarehouseProduct = createAsyncThunk(
  "product/warehouseProductSearchGridV2",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductService.warehouseProductSearchGridV2(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getProductByIdV2 = createAsyncThunk(
  "product/getProductByIdV2",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ProductService.getProductByIdV2(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const addProductV3 = createAsyncThunk(
  "product/addProductV3",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.addProductV3(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateProductV3 = createAsyncThunk(
  "product/updateProductV3",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.updateProductV3(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateProductVariantV2 = createAsyncThunk(
  "product/updateProductVariantV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.updateVariantV2(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const syncProductPartnerApi = createAsyncThunk(
  "product/syncProductPartnerApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.syncProductPartner(payload);
      if (onSuccess) onSuccess(response);
      // openNotification(
      //   "success",
      //   Utils.setLocale("admin.settings.popup.notification.success"),
      //   Utils.setLocale("admin.settings.popup.notification.title"),
      // );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const groupCategoryV2Api = createAsyncThunk(
  "product/groupCategoryV2Api",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.groupCategoryV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const applyOtherOptionApi = createAsyncThunk(
  "product/applyOtherOptionApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.applyOtherOption(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const applyAdditionOptionApi = createAsyncThunk(
  "product/applyAdditionOptionApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.applyAdditionOption(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//PRODUCT UNIT BY PARTNER ID
export const getAllUnit = createAsyncThunk(
  "product/getAllUnit",
  async (payload, { rejectWithValue }) => {
    try {
      const { partnerId } = payload;
      const response = await ProductService.getAllUnit(partnerId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const upsertUnit = createAsyncThunk(
  "product/upsertUnit",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await ProductService.upsertUnit(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteUnit = createAsyncThunk(
  "product/deleteUnit",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response = await ProductService.deleteUnit(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  syncLoading: false,
  productList: [],
  productWarehouseList: [],
  productWarehouseListV2: [],
  productDetail: {},
  productMobileDetail: {},
  totalCount: 0,
  totalWarehouseCount: 0,

  warehouseProductSelectList: [],

  productUnit: [],
  productListV2: [],
  warehouseProductListV2: [],
  totalWarehouseCountV2: 0,
  totalCountV2: 0,
  productDetailV2: {},
};
export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setProductDetail: (state) => {
      state.loading = {};
    },
    showSyncLoading: (state) => {
      state.syncLoading = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductApi.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getProductApi.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
        state.productList = action.payload.data;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getProductApi.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
      })
      .addCase(getProductById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.productDetail = action.payload;
      })
      .addCase(getProductById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getProductMobileById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductMobileById.fulfilled, (state, action) => {
        state.loading = false;
        state.productMobileDetail = action.payload;
      })
      .addCase(getProductMobileById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addProductApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(addProductApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addProductApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProductApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductStateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProductStateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductStateApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(delProductApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delProductApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delProductApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(copyProductsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(copyProductsApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(copyProductsApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(groupCategoryApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(groupCategoryApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(groupCategoryApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStatusProductsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(changeStatusProductsApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStatusProductsApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(discountProductsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(discountProductsApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(discountProductsApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductVariantApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateProductVariantApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductVariantApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllProductWarehouse.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllProductWarehouse.fulfilled, (state, action) => {
        state.loading = false;
        state.productWarehouseList = action.payload;
      })
      .addCase(getAllProductWarehouse.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getProductWarehouseList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getProductWarehouseList.fulfilled, (state, action) => {
        state.loading = false;

        state.productWarehouseListV2 = action.payload.data;
        state.totalWarehouseCount = action.payload.totalCount;
      })
      .addCase(getProductWarehouseList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(delMultiProductsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(delMultiProductsApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delMultiProductsApi.rejected, (state, action) => {
        state.loading = false;
      })

      //PRODUCT V2/V3
      .addCase(getAllProduct.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getAllProduct.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
        state.productListV2 = action.payload.data;
        state.totalCountV2 = action.payload.totalCount;
      })
      .addCase(getAllProduct.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
      })

      //WAREHOUSE PRODUCT SELECT LIST
      .addCase(getSelectListWarehouseProduct.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getSelectListWarehouseProduct.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
        state.warehouseProductSelectList = action.payload;
      })
      .addCase(getSelectListWarehouseProduct.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
      })

      //WAREHOUSE PRODUCT TABLE LIST
      .addCase(getAllWarehouseProduct.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getAllWarehouseProduct.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
        state.warehouseProductListV2 = action.payload.data;
        state.totalWarehouseCountV2 = action.payload.totalCount;
      })
      .addCase(getAllWarehouseProduct.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
      })

      .addCase(getProductByIdV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductByIdV2.fulfilled, (state, action) => {
        state.loading = false;
        state.productDetailV2 = action.payload;
      })
      .addCase(getProductByIdV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(addProductV3.pending, (state) => {
        state.loading = true;
      })
      .addCase(addProductV3.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addProductV3.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateProductV3.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProductV3.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductV3.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateProductVariantV2.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateProductVariantV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProductVariantV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(syncProductPartnerApi.pending, (state) => {
        state.syncLoading = true;
      })
      .addCase(syncProductPartnerApi.fulfilled, (state, action) => {
        state.syncLoading = false;
      })
      .addCase(syncProductPartnerApi.rejected, (state, action) => {
        state.syncLoading = false;
      })

      .addCase(groupCategoryV2Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(groupCategoryV2Api.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(groupCategoryV2Api.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(applyOtherOptionApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(applyOtherOptionApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(applyOtherOptionApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(applyAdditionOptionApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(applyAdditionOptionApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(applyAdditionOptionApi.rejected, (state, action) => {
        state.loading = false;
      })

      //UNIT BY PARTNER ID
      .addCase(getAllUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUnit.fulfilled, (state, action) => {
        state.loading = false;
        state.productUnit = action.payload;
      })
      .addCase(getAllUnit.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(upsertUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(upsertUnit.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(upsertUnit.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteUnit.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setProductDetail, showSyncLoading } = productSlice.actions;

export default productSlice.reducer;
